import useViewCombatantActionCounts from '../composables/useViewCombatantActionCounts'
import handleError from './handleError'
import store from '../store/index'
//----------------------
// is contiguous action
//----------------------
/*
previous round:
1. combatant take all actions
2. last action an actual
new round:
3. new action same as last action in prev rnd
*/
export default function isContiguousAction(parm) {
  console.log('----------------------')
  console.log('IN isContiguousAction round = ' + parm.payload.round)
  const this_store = store.state.combat
  const maxCA = this_store.config.max_ca
  let check_last_action = false

  let return_parm = {
    contiguous: false,
    last_action: '',
  }
  //
  return new Promise((resolve) => {
    //----------------------------------------
    // get count for specific round/combatant
    //----------------------------------------
    let call = useViewCombatantActionCounts(parm.payload)
    call
      .then((response) => {
        let counts = response[0]

        // console.log("counts.action_name = " + counts.action_name);
        // console.log("counts.actual = " + counts.actual);
        // console.log("counts.round = " + counts.round);
        // console.log("counts.number = " + counts.number);
        // console.log("counts.action_count = " + counts.action_count);
        // console.log(
        //   "counts.actual_action_count = " + counts.actual_action_count
        // );

        //-----------------------------------
        // check any actions in previous rnd
        //-----------------------------------
        if (!counts) {
          console.log('no actions...')
          return_parm.contiguous = false
          //------------------------------------------------
          // check overall action-count in prev rnd < maxCA
          //------------------------------------------------
        } else if (counts.action_count < maxCA) {
          console.log('counts.action_count < maxCA = true')
          //--------------------------------------
          // check if actuals < this combatant ca
          //--------------------------------------
          if (counts.actual_action_count < parm.combatant_ca) {
            //----------------
            // missing action
            //----------------
            console.log('counts.actual_action_count < parm.combatant_ca = true')
            console.log('MISSING ACTION!')
            //-----------------------------------------
            // all actions present - check last action
            //-----------------------------------------
          } else {
            console.log('check last action')
            return_parm.contiguous = true
            return_parm.last_action = counts.action_name
          }
        } else {
          //-----------------------------------------
          // all actions present - check last action
          //-----------------------------------------
          console.log('check last action')
          check_last_action = true
        }
        //------------------------------------------
        // no action missing but need to check last
        // action is an actual in prev rnd
        //------------------------------------------
        if (check_last_action) {
          console.log('checking last action...')
          //---------------------------------
          // last action = actual - > contig
          //---------------------------------
          if (counts.actual) {
            console.log('last action = actual')
            return_parm.contiguous = true
            return_parm.last_action = counts.action_name
            //-----------------------------------------
            // last action = NOT actual - > NOT contig
            //-----------------------------------------
          } else {
            console.log('last action = false')
            return_parm.contiguous = false
          }
        }
        //
        resolve(return_parm)
      })
      .catch((err) => {
        handleError(err, 99)
      })
  })
}
